var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.carrier_type)?_c('div',[_c('carrier-type-form',{model:{value:(_vm.carrier_type),callback:function ($$v) {_vm.carrier_type=$$v},expression:"carrier_type"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }